import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';



@NgModule({
  declarations: [FileUploadComponent],
  imports: [
    CommonModule,
    ModulosDeFormulario
  ],
  exports: [FileUploadComponent]
})
export class FileUploadModule { }
